import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal','tgl1', 'tgl2','outstand', 'nomor', 'crewinfo', 'nomorAdv', 'namaacc','jenisAdv'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/advsettle${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    getcoa(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`coa/getcoa/${obj.tahun}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    pasalpph() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/apinv/pasalpph");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },   
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`advsettle/detail/${obj.advSttlKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    idocs(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`advsettle/idocs/${obj.advSttlKey}`,obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }, 
    iDocURI() {
        // const instance = axios.create({
        //     baseURL: 'https://idocs.metrotvnews.tv/api/docfin/browse/',
        //     header:{Authorization: 'Basic Y2VQb0lCWHd2Z3RId3JaSDh0OWw3a1g4Y2JjNFRJQmI6OTE3T1FDd3BGSVc4QkhYcFlXZlg3TXp4bjByMUw3Mmk='},
        //   });
        // const instance = axios.create({
        //     baseURL: 'https://idocs.metrotvnews.tv/api/docfin',
        //     auth: {username : 'cePoIBXwvgtHwrZH8t9l7kX8cbc4TIBb' , password : '917OQCwpFIW8BHXpYWfX7Mzxn0r1L72i'}
        //   });
        // return instance.getURI({url:'/browse'});

        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.get(`/browse`,{
                        baseURL: 'https://idocs.metrotvnews.tv/api/docfin',
                        auth: {username : 'cePoIBXwvgtHwrZH8t9l7kX8cbc4TIBb' , password : '917OQCwpFIW8BHXpYWfX7Mzxn0r1L72i'}
                      });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });

    },

    detailadvance(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`advance/detail/${obj.advanKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailNote(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`expensenote/detail/${obj.trxhdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("advsettle", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    saveidocs(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("advsettle/save", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`advsettle/${obj.advSttlKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    posting(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`advsettle/posting/${obj.advSttlKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postingUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`advsettle/unposting/${obj.advSttlKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postingselected(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.put(`advsettle/postingselected`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    unpostingselected(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.put(`advsettle/unpostingselected`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    submit(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`advsettle/submit/${obj.advSttlKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    submitUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`advsettle/unsubmit/${obj.advSttlKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'crewinfo', 'nomorAdv', 'namaacc'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/advsettle/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'advsettle.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },
    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.advSttlKey);
                url = `/advsettle/print`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    printpb(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.advSttlKey);
                url = `/advsettle/printpb`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    printpbmultiple(arrInv) {
        return new Promise(async (resolve, reject) => {
            try {                
                const { data } = await axios.get(`/advsettle/printpbmultiple?arrInv=${encodeURIComponent(JSON.stringify(arrInv))}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.advSttlKey);
                url = `/advsettle/printjv`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printjvmultiple(arrInv) {
        return new Promise(async (resolve, reject) => {
            try {                
                const { data } = await axios.get(`/advsettle/printjvmultiple?arrInv=${encodeURIComponent(JSON.stringify(arrInv))}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },  

};